import { SvgIcon, type SvgIconProps } from '@mui/material';
import orangePng from './orange.png';

const OrangeMoneyIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} sx={{ width: 40, height: 40, ...props.sx }} viewBox='0 0 100 100'>
    <image href={orangePng} width='100%' height='100%' />
  </SvgIcon>
);

export default OrangeMoneyIcon;
